import { Component, ChangeDetectionStrategy, computed, input, output } from '@angular/core';
import { AddressBookI } from '@store/modals';

@Component({
  selector: 'app-delivery-address-bar',
  templateUrl: './delivery-address-bar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeliveryAddressBarComponent {
  address = input.required<AddressBookI>();
  changeAddress = output<void>();

  formattedAddress = computed(() => {
    const addr = this.address();
    if (!addr) return '';
    return [addr.buildingDetails, addr.localityDetails, addr.landmark]
      .filter(Boolean)
      .join(', ');
  });
}
